/**
 * Sort comparators matching Postgres ORDER BY semantics, so converted selectors keep the exact
 * ordering the SQL queries produced: ASC sorts nulls last, DESC sorts nulls first, booleans sort
 * false < true.
 */

type Sortable = string | number | boolean | null | undefined;

function rank(value: Sortable): number | string {
  if (typeof value === "boolean") return value ? 1 : 0;
  return value as number | string;
}

export function compareAsc(a: Sortable, b: Sortable): number {
  const aNull = a == null;
  const bNull = b == null;
  if (aNull && bNull) return 0;
  if (aNull) return 1;
  if (bNull) return -1;
  const ra = rank(a);
  const rb = rank(b);
  if (ra < rb) return -1;
  if (ra > rb) return 1;
  return 0;
}

export function compareDesc(a: Sortable, b: Sortable): number {
  const aNull = a == null;
  const bNull = b == null;
  if (aNull && bNull) return 0;
  if (aNull) return -1;
  if (bNull) return 1;
  const ra = rank(a);
  const rb = rank(b);
  if (ra < rb) return 1;
  if (ra > rb) return -1;
  return 0;
}

/** Composes comparators into a multi-key ORDER BY. */
export function chainComparators<T>(...comparators: ((a: T, b: T) => number)[]): (a: T, b: T) => number {
  return (a, b) => {
    for (const compare of comparators) {
      const result = compare(a, b);
      if (result !== 0) return result;
    }
    return 0;
  };
}
